import React from 'react';
import noImg from "../../assets/img/404_img.png"

function getImageURL(url) {
    // Check if the URL starts with 'http' or '/' to determine if it's absolute or relative
    if (url) {
      if (url.startsWith('http')) {// || url.startsWith('/')) {
        return url;
      } else {
        return `${process.env.REACT_APP_IMAGES_URL}/${url}`;
      }
  }
}

function ImageWithFallback({ src, alt, className = "", style={},  fallbackSrc = noImg }) {
  const handleError = (event) => {
    event.target.src = fallbackSrc;
    event.target.alt = getImageURL(src);
  };

  return <img src={getImageURL(src)} alt={alt}  className={className} style={style} onError={handleError} />
}

export default ImageWithFallback;